import { AnyAction } from 'redux';
import {
  CommonInsuranceData,
  GlobalAction,
  GlobalActions,
  isAzam,
  ProduktDeleted,
  ReplaceState,
  updateStateWithCommonInsuranceInfo,
  WrappedSavedStates,
  WrappedSavedStatesLoaded,
} from '@ps20-frontend/shop-integration-redux';
import cloneDeep from 'lodash/cloneDeep';
import { App, FeatureToggles } from '@ps20-frontend/frontend-models';
import { Zahlungsart } from '@ps20/bff-models';
import {
  migrateAktionsnachlassAktion10, migrateAngebotsdatum,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { INITIAL_STATE } from '../initialState';
import { loadAndMigrateVhvState } from '../migrations';

function handleSavedStatesLoaded(state: IAppState, action: AnyAction): IAppState {
  const actionPayload: WrappedSavedStates = (action as GlobalAction<WrappedSavedStatesLoaded>)
    .payload.savedStatesLoaded;
  const loadedAppState = actionPayload.find(
    loadedState =>
      loadedState.appId === App.VHV_V2 &&
      loadedState.angebotsId === state.angebotsId &&
      loadedState,
  );
  if (loadedAppState != null) {
    if (isAzam(state.transientState.role)) {
      if (state.transientState.isRisikoortVnAdresse) {
        delete loadedAppState.state.risikoort.plz;
        delete loadedAppState.state.risikoort.hausnummer;
        delete loadedAppState.state.risikoort.ort;
        delete loadedAppState.state.risikoort.strasse;
      }
      delete loadedAppState.state.versicherungsnehmer.geburtsdatum;
      if (state.vertragsoptionen.zahlungsart === Zahlungsart.MAKLER_INKASSO) {
        delete loadedAppState.state.vertragsoptionen.zahlungsart;
      }
    }
    migrateAngebotsdatum(loadedAppState.state);
    migrateAktionsnachlassAktion10(
      loadedAppState.state,
      state.transientState.featureToggles as FeatureToggles,
    );
    return loadAndMigrateVhvState(
      state,
      loadedAppState.state,
      loadedAppState.state.vertragsoptionen?.beibehalten,
    );
  } else {
    return state;
  }
}

export const rootReducer =
  // @ts-expect-error higher-order reducer parameter type cannot be inferred
  reducer =>
  (state: IAppState, action: AnyAction): IAppState => {
    switch (action.type) {
      case GlobalActions.SAVED_STATES_LOADED:
        return handleSavedStatesLoaded(state, action);
      case GlobalActions.ANGEBOTS_ID_RECEIVED: {
        return {
          ...state,
          angebotsId: action.payload,
        };
      }
      case GlobalActions.REPLACE_STATE: {
        const actionPayload: ReplaceState<IAppState> = action.payload;
        if (actionPayload.appId === App.VHV_V2 && actionPayload.angebotsId === state.angebotsId) {
          return actionPayload.appState;
        }
        return state;
      }
      case GlobalActions.COMMON_INSURANCE_DATA_RECEIVED: {
        const actionPayload: CommonInsuranceData = action.payload;
        return updateStateWithCommonInsuranceInfo(actionPayload, state, App.VHV_V2);
      }
      case GlobalActions.PRODUKT_DELETED: {
        const actionPayload: ProduktDeleted = action.payload;
        if (
          actionPayload.angebotsIds.some(
            angebotsId =>
              angebotsId.appId === App.VHV_V2 && angebotsId.angebotsId === state.angebotsId,
          )
        ) {
          const newState: IAppState = cloneDeep(INITIAL_STATE);
          newState.vertragsoptionen.zahlungsweise = state.vertragsoptionen.zahlungsweise;
          newState.vertragsoptionen.zahlungsart = state.vertragsoptionen.zahlungsart;

          newState.versicherungsnehmer.geburtsdatum = state.versicherungsnehmer.geburtsdatum;
          newState.versicherungsnehmer.isAssekuranztarif =
            state.versicherungsnehmer.isAssekuranztarif;
          newState.vorbelegungen.versicherungsnehmerVorbelegt =
            state.vorbelegungen.versicherungsnehmerVorbelegt;
          newState.transientState.role = state.transientState.role;
          return newState;
        }
        return state;
      }
      default:
        return reducer(state, action);
    }
  };
